import { render, staticRenderFns } from "./Licenze.vue?vue&type=template&id=7290f3b4&"
import script from "./Licenze.vue?vue&type=script&lang=js&"
export * from "./Licenze.vue?vue&type=script&lang=js&"
import style0 from "./Licenze.vue?vue&type=style&index=0&id=7290f3b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports